import React, { useState } from "react";
import { Button, Checkbox, Form, Input, Select, ConfigProvider, DatePicker } from "antd";
import { StyleProvider } from "@ant-design/cssinjs";
import CountrySelect from "../../../../components/countrySelect";
import ProvinceSelect from "../../../../components/provinceSelect";
import TextArea from "antd/es/input/TextArea";
import PhoneInput from "react-phone-input-2";
import RowForm from "./RowForm";
import preventiviService from "../../../../services/preventivi.service";
import { useTranslation } from "react-i18next";
import { antdLocales } from "./AntdLocale";
import { useParams } from "react-router-dom";

const { RangePicker } = DatePicker;

function SingleStep({ state, setState }) {
    const { uuid } = useParams();
    const { t, i18n } = useTranslation("common");
    const [categories, setCategories] = React.useState([]);

    React.useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        preventiviService.getCategoriesFromRichiesta(uuid).then(
            (result) => {
                result = result.data;
                var categories_av = [];
                result.map((cat) => {
                    if (cat.name) {
                        if (!categories_av.some(obj => obj.descr == cat.descr)) {
                            categories_av.push(cat);
                        }
                    }
                });
                setCategories(categories_av);
            },
            (error) => { }
        );
    };

    function errorStyle(element, condition = true) {
    return ({
        borderColor: !(element && condition) ? 'red' : '#ccc',
        borderWidth: 1,
        borderStyle: 'solid',
    })}
    return (
        <div
            className="my-10 backdrop-blur-lg w-full h-full 
    rounded-lg py-10 border border-dashed border-gray-500
    px-5 md:px-20 min-h-[660px]"
        >
            <StyleProvider hashPriority="high">
                <div className="grid grid-cols-12 gap-5">

                    {/* STEP 1*/}
                    <RowForm
                        label={t("request.step1.name")}
                        input={
                            <Input
                                placeholder={t("request.step1.placeholderName")}
                                value={state.name}
                                onChange={(e) => setState({ ...state, name: e.target.value })}
                                style={errorStyle(state.name)}
                            />
                        }
                    />
                    <RowForm
                        label={t("request.step1.surname")}
                        input={
                            <Input
                                placeholder={t("request.step1.placeholderSurname")}
                                value={state.surname}
                                onChange={(e) =>
                                    setState({ ...state, surname: e.target.value })
                                }
                                style={errorStyle(state.surname)}
                            />
                        }
                    />
                    <RowForm
                        label={t("request.step1.email")}
                        input={
                            <Input
                                placeholder="Email"
                                value={state.email}
                                onChange={(e) => setState({ ...state, email: e.target.value })}
                                style={errorStyle(state.email, /\S+@\S+\.\S+/.test(state.email))}
                            />
                        }
                    />
                    <RowForm
                        label={t("request.step1.phone")}
                        input={
                            <PhoneInput
                                className="!text-black !w-full phone-input"
                                country={"it"}
                                value={state.phone}
                                onChange={(phone) => setState({ ...state, phone: phone })}
                                style={errorStyle(state.phone)}
                            />
                        }
                    />
                    {/*<RowForm
                        label={t("request.step1.contact")}
                        input={
                            <Select
                                className="!w-full"
                                size="normal"
                                value={state.contact_type}
                                onChange={(e) => setState({ ...state, contact_type: e })}
                                options={[
                                    {
                                        value: 1,
                                        label: "Email",
                                    },
                                    {
                                        value: 2,
                                        label: "Email & Whatsapp",
                                    },
                                ]}
                            />
                        }
                    />*/}
                


                {/* STEP 2 ROOM*/}
                <RowForm
                    label={t("request.step2.trattamento")}
                    input={
                        <Select
                            style={{
                                width: "100%",
                            }}
                            value={state.treatment}
                            onChange={(e) =>
                                setState({
                                    ...state,
                                    treatment: e
                                })
                            }
                            options={categories?.map((cat) => {
                                return {
                                    value: cat.treatment, label: <>{cat.descr}</>
                                };
                            })}
                            
                        />
                    }
                />



                    { /*data*/}
                    <RowForm
                        label={t("request.step2.checkinCheckout")}
                        input={
                            <ConfigProvider locale={antdLocales[i18n.language]}>
                                <RangePicker
                                    disabledDate={false}
                                    className="w-full"
                                    placeholder={["Checkin", "Checkout"]}
                                    format={"ddd DD MMM YYYY"}
                                    value={state.dates}
                                    onChange={(newDates) =>
                                        setState({
                                            ...state,
                                            dates: [newDates[0], newDates[1]],
                                        })
                                    }
                                />
                            </ConfigProvider>
                        }
                    />

                    <RowForm
                        label={t("request.step1.stanze")}
                        input={
                            <Select
                                style={{
                                    width: "100%",
                                }}
                                value={state.roomsNum}
                                onChange={(e) =>
                                    setState({
                                        ...state,
                                        roomsNum: e
                                    })
                                }
                                options={
                                    Array.from({ length: 6 }, (_, i) => ({ value: i + 1, label: i + 1 }))

                                }
                            />
                        }
                        span={3}
                    />

                    <RowForm
                        label={t("request.step1.adulti")}
                        input={
                            <Select
                                style={{
                                    width: "100%",
                                }}
                                value={state.adults}
                                onChange={(e) =>
                                    setState({
                                        ...state,
                                        adults: e
                                    })
                                }
                                options={
                                    Array.from({ length: 10 }, (_, i) => ({ value: i + 1, label: i + 1 }))

                                }
                            />
                        }
                        span={3}
                    />

                    <RowForm
                        label={t("request.step1.bambini")}
                        input={
                            <Select
                                style={{
                                    width: "100%",
                                }}
                                value={state.kids}
                                onChange={(e) =>
                                    setState({
                                        ...state,
                                        kids: e
                                    })
                                }
                                options={Array.from({ length: 7 }, (_, i) => ({ value: i, label: i }))}
                            />
                        }
                        span={3}
                    />
                    

                </div>



                    {/* STEP 3 NOTES*/}

                    


                    {/* STEP 4 PRIVACY*/}

                    <div className="col-span-12 mt-10 flex flex-row items-start">
                        <Checkbox
                            onChange={(e) =>
                                setState({ ...state, privacy: e.target.checked })
                            }
                            value={state.privacy}
                            checked={state.privacy}
                            className="w-full"
                        >
                            <div className="flex flex-col w-full text-white gap-2">
                                <h4 className="text-xl">{t("request.step1.privacy")}</h4>
                                {/*<p className="text-md text-gray-300">
                                    {t("request.step1.privacyBody")}
                                </p>*/}
                            </div>
                        </Checkbox>
                    </div>

                    <div className="col-span-12 mt-2 flex flex-row items-start">
                        <Checkbox
                            onChange={(e) =>
                                setState({ ...state, newsletter: e.target.checked })
                            }
                            value={state.newsletter}
                            checked={state.newsletter}
                            className="w-full"
                        >
                            <div className="flex flex-col w-full text-white gap-2">
                                <h4 className="text-xl">{t("request.step1.newsletter")}</h4>
                                {/*<p className="text-md text-gray-300">
                                    {t("request.step1.newsletterBody")}
                                </p>*/}
                            </div>
                        </Checkbox>
                    </div>
                
                <div className="mt-10">
                    <RowForm
                        label={t("request.step3.notes")}
                        input={
                            <TextArea
                                value={state.notes}
                                onChange={(e) => setState({ ...state, notes: e.target.value })}
                                placeholder={t("request.step3.requests")}
                                autoSize={{ minRows: 3, maxRows: 5 }}
                            />
                        }
                    />
                </div>
            </StyleProvider>
        </div>
    );
}

export default SingleStep;
